import { NgForOf, NgIf } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { IMasterDupePair } from '../../../shared/interfaces/duplikit-interfaces';
import { DuplicateService } from '../../duplicate.service';
import {
  DuplikitHistoryAssociationMergesComponent
} from './duplikit-history-association-merges/duplikit-history-association-merges.component';

@Component({
  selector: 'app-duplikit-history-all-by-master-id',
  templateUrl: './duplikit-history-all-by-master-id.component.html',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    NgIf,
    NgForOf,
    DuplikitHistoryAssociationMergesComponent,
    MatTooltip
  ],
  styleUrls: ['./duplikit-history-all-by-master-id.component.scss']
})
export class DuplikitHistoryAllByMasterIdComponent implements OnInit {
  dedupeTaskId;
  masterDupePairs: IMasterDupePair[];
  masterDupePairsLoading = true;

  mergeLogVisibility: boolean[] = [];
  @ViewChild('mergeLog') mergeLog: ElementRef;
  showDetails = false;

  constructor(
    public dialogRef: MatDialogRef<[]>,
    private duplicateService: DuplicateService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.dedupeTaskId = this.data;

    this.duplicateService.getMasterDupePairingsForDedupeTask(this.dedupeTaskId).subscribe((res) => {
      this.masterDupePairs = res;
      this.masterDupePairsLoading = false;
    }, (error) => {
      console.error(error);
    });
  }

  toggleMergeLogs(duplicateId: number): void {
    this.mergeLogVisibility[duplicateId] = !this.mergeLogVisibility[duplicateId];
    this.showDetails = true;
  }

}
